export default __webpack_public_path__ + "fonts/87ebdc0f30585dff52505d636b7f03a9.woff2";